import { useCrmStore } from "features/Crm/store/useCrmStore";

export const useCustomColumnLockedModal = () => {
  const setIsCustomColumnLockedModalOpen = useCrmStore(
    (state) => state.setIsCustomColumnLockedModalOpen
  );
  const isCustomColumnLockedModalOpen = useCrmStore(
    (state) => state.isCustomColumnLockedModalOpen
  );

  const openCustomColumnLockedModal = () => {
    setIsCustomColumnLockedModalOpen(true);
  };
  const closeCustomColumnLockedModal = () => {
    setIsCustomColumnLockedModalOpen(false);
  };

  return {
    isCustomColumnLockedModalOpen,
    openCustomColumnLockedModal,
    closeCustomColumnLockedModal,
  };
};
